import { TableCell, TableRow } from '@mui/material';
import PriceSpan from '../../../shared/ui/price-span';
import { SALARY_ENTRY_TYPES } from '@sr/dto';
import { SUMMARY_COLUMNS } from './use-summary-table-options';

export const TotalsRow = ({ totals, rowColor }: { totals: Record<SALARY_ENTRY_TYPES | 'total', number>; rowColor?: string }) => {
  return (
    <TableRow sx={{ backgroundColor: rowColor || undefined }}>
      <TableCell sx={{ borderTop: '3px black' }} align="right">
        Итого:
      </TableCell>
      {[...SUMMARY_COLUMNS.map(({ key }) => key), 'total' as const].map((key) => (
        <TableCell key={key} align="right" sx={{ whiteSpace: 'nowrap' }}>
          {totals[key] < 0 && '−'}
          <PriceSpan price={totals[key]} />
        </TableCell>
      ))}
    </TableRow>
  );
};
